import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[var(--vp-paper)]">
      {/* Header */}
      <div className="bg-white border-b border-[var(--vp-line)] sticky top-0 z-50">
        <div className="container-custom py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 text-[var(--vp-ink)] hover:text-[var(--vp-pink)] transition-colors">
              <ArrowLeft className="w-5 h-5" />
              <span className="font-medium">Zpět na hlavní stránku</span>
            </Link>
            <div className="flex items-center gap-2">
              <FileText className="w-5 h-5 text-[var(--vp-pink)]" />
              <span className="font-semibold text-[var(--vp-ink)]">Obchodní podmínky</span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="container-custom py-12 max-w-4xl"
      >
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-[var(--shadow-soft)] border border-[var(--vp-line)]">
          <h1 className="text-3xl md:text-4xl font-semibold text-[var(--vp-ink)] mb-2">
            Všeobecné obchodní podmínky
          </h1>
          <p className="text-[var(--vp-ink)]/60 mb-8">
            pro poskytování digitální služby „Výzva přijata"
          </p>

          <div className="prose prose-lg max-w-none text-[var(--vp-ink)]/80">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">1. Identifikace poskytovatele</h2>
              <p className="leading-relaxed">
                Jakub Poloch<br />
                IČO: 23393891<br />
                Sídlo: Fráni Šrámka 2457/28, 709 00 Ostrava – Mariánské Hory<br />
                Podnikající fyzická osoba dle živnostenského zákona<br />
                E-mail: <a href="mailto:info@vyzvaprijata.eu" className="text-[var(--vp-pink)] hover:underline">info@vyzvaprijata.eu</a><br />
                Telefon: +420 721 665 622<br />
                Web: <a href="https://www.vyzvaprijata.eu" target="_blank" rel="noopener noreferrer" className="text-[var(--vp-pink)] hover:underline">www.vyzvaprijata.eu</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">2. Předmět služby</h2>
              <p className="mb-4">Poskytovatel poskytuje digitální zábavní službu spočívající v zasílání tematických SMS výzev dle zvoleného balíčku (dále jen „Služba").</p>
              <p className="mb-4">Služba je určena výhradně osobám starším 18 let.</p>
              <p>Balíčky jsou poskytovány jednorázově za cenu uvedenou na webu (99–349 Kč dle zvoleného balíčku). Veškeré ceny jsou uvedeny v českých korunách (CZK).</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">3. Charakter služby</h2>
              <p className="mb-2">Služba má výhradně zábavní a inspirační charakter.</p>
              <p className="mb-2">Může obsahovat fyzické výzvy a úkoly zahrnující konzumaci alkoholu.</p>
              <p className="mb-2">Účast na plnění výzev je dobrovolná a plně na odpovědnosti uživatele.</p>
              <p>Poskytovatel neposkytuje zdravotní, psychologické ani jiné odborné služby.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">4. Vznik smlouvy a zahájení plnění</h2>
              <p className="mb-4">Kupní smlouva vzniká odesláním závazné objednávky prostřednictvím webového rozhraní Poskytovatele.</p>
              <p className="mb-4">Uživatel byl před uzavřením smlouvy poučen o tom, že udělením souhlasu se zahájením plnění před uplynutím 14denní lhůty ztrácí právo na odstoupení od smlouvy dle § 1837 písm. l) občanského zákoníku.</p>
              <p className="mb-4">Uživatel výslovně souhlasí se zahájením poskytování služby před uplynutím lhůty pro odstoupení od smlouvy.</p>
              <p className="mb-4">Okamžikem zahájení odesílání SMS dochází ke splnění digitální služby a ztrátě práva na odstoupení.</p>
              <p className="mb-4">Služba se spouští v termínu vyplývajícím z podmínek a charakteru zvoleného balíčku.</p>
              <p>Služba je považována za dodanou okamžikem zahájení odesílání první SMS zprávy v rámci zakoupeného balíčku.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">5. Zasílání SMS a technické podmínky</h2>
              <p className="mb-4">SMS jsou odesílány prostřednictvím třetí strany (SMS brány GoSMS).</p>
              <p className="mb-4">Počet a frekvence SMS jsou dány konkrétním balíčkem (např. 6–12 SMS za 1 den nebo 2 SMS denně po dobu až 14 dnů).</p>
              <p className="mb-4">Uživatel nehradí žádné další náklady nad rámec ceny zakoupeného balíčku. Náklady na mobilní služby nebo internetové připojení si hradí samostatně dle podmínek svého operátora.</p>
              <p className="mb-4">Pro využívání služby je nezbytné vlastnit mobilní telefon schopný přijímat SMS zprávy a mít aktivní telefonní číslo u mobilního operátora působícího na území České republiky.</p>
              <p className="mb-2">Poskytovatel nenese odpovědnost za:</p>
              <ul className="list-disc list-inside mb-4 space-y-1">
                <li>nedoručení SMS způsobené mobilním operátorem,</li>
                <li>chybně zadané telefonní číslo,</li>
                <li>blokaci zpráv na straně příjemce,</li>
                <li>technické výpadky mimo svou kontrolu.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">6. Zadání telefonního čísla třetí osoby</h2>
              <p className="mb-2">Pokud uživatel zadává telefonní číslo jiné osoby, prohlašuje, že:</p>
              <ul className="list-disc list-inside mb-4 space-y-1">
                <li>má souhlas této osoby se zasíláním SMS,</li>
                <li>tato osoba je starší 18 let,</li>
                <li>tato osoba byla informována o charakteru služby.</li>
              </ul>
              <p>Poskytovatel nenese odpovědnost za porušení povinností uživatele vůči třetím osobám.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">7. Odpovědnost a omezení odpovědnosti</h2>
              <p className="mb-4">Uživatel je povinen posoudit svůj zdravotní stav, fyzickou způsobilost a aktuální okolnosti před plněním jakékoli výzvy. Poskytovatel neodpovídá za plnění výzev v rozporu se zdravým rozumem, právními předpisy nebo osobními limity uživatele.</p>
              <p className="mb-2">Poskytovatel neodpovídá za:</p>
              <ul className="list-disc list-inside mb-4 space-y-1">
                <li>zdravotní újmu,</li>
                <li>škodu na majetku,</li>
                <li>újmu způsobenou plněním výzev,</li>
                <li>následky nevhodného či nepřiměřeného plnění výzev.</li>
              </ul>
              <p>Odpovědnost Poskytovatele je omezena maximálně do výše ceny zakoupeného balíčku.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">8. Reklamace</h2>
              <p className="mb-4">Uživatel je oprávněn uplatnit reklamaci v případě prokazatelné vady služby, zejména pokud dojde k technické chybě na straně Poskytovatele.</p>
              <p className="mb-4">Reklamaci lze uplatnit e-mailem na adrese <a href="mailto:info@vyzvaprijata.eu" className="text-[var(--vp-pink)] hover:underline">info@vyzvaprijata.eu</a>.</p>
              <p className="mb-4">Poskytovatel vyřídí reklamaci bez zbytečného odkladu, nejpozději do 30 dnů ode dne jejího uplatnění, pokud se s uživatelem nedohodne jinak.</p>
              <p className="mb-4">V případě uznání reklamace může být uživateli poskytnuta přiměřená náprava, zejména opětovné poskytnutí služby nebo vrácení zaplacené částky.</p>
              <p>Poskytovatel neodpovídá za nedoručení způsobené mobilním operátorem, chybně zadaným telefonním číslem nebo jinými okolnostmi mimo jeho kontrolu.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">9. Ochrana osobních údajů</h2>
              <p className="mb-4">Telefonní čísla jsou zpracovávána výhradně za účelem realizace zakoupené služby.</p>
              <p className="mb-4">Telefonní čísla nejsou využívána k marketingovým účelům ani předávána třetím osobám s výjimkou zpracovatele SMS brány GoSMS.</p>
              <p>Další informace jsou uvedeny v <a href="/gdpr.html" className="text-[var(--vp-pink)] hover:underline">Zásadách ochrany osobních údajů</a>.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">10. Mimosoudní řešení spotřebitelských sporů</h2>
              <p>K mimosoudnímu řešení spotřebitelských sporů ze smlouvy je příslušná Česká obchodní inspekce, IČO: 000 20 869, se sídlem Štěpánská 567/15, 120 00 Praha 2, internetová adresa: <a href="https://www.coi.cz" target="_blank" rel="noopener noreferrer" className="text-[var(--vp-pink)] hover:underline">https://www.coi.cz</a></p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[var(--vp-ink)] mb-4">11. Závěrečná ustanovení</h2>
              <p className="mb-4">Tyto obchodní podmínky jsou platné a účinné od 1. července 2024.</p>
              <p>Poskytovatel si vyhrazuje právo tyto obchodní podmínky přiměřeně měnit či doplňovat. Změny nabývají účinnosti jejich zveřejněním na webových stránkách Poskytovatele. Pro konkrétní objednávku platí znění obchodních podmínek účinné v době jejího uzavření.</p>
            </section>
          </div>
        </div>

        {/* Back button */}
        <div className="text-center mt-8">
          <Link to="/">
            <Button className="btn-primary px-6 py-3 rounded-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zpět na hlavní stránku
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default TermsPage;
